"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextInCircle = function TextInCircle(_ref) {
  var text = _ref.text,
      textColor = _ref.textColor;
  return (0, _core.jsx)("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    fill: textColor,
    fontSize: "250",
    dy: ".3em"
  }, text);
};

var CircleText = (
/*#__PURE__*/
0, _styledBase.default)(function (_ref2) {
  var className = _ref2.className,
      randomId = _ref2.randomId,
      title = _ref2.title,
      text = _ref2.text,
      textColor = _ref2.textColor;
  return (0, _core.jsx)("svg", {
    className: className,
    role: "img",
    "aria-labelledby": "\"circle-\"".concat(randomId),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, (0, _core.jsx)("title", {
    id: "\"circle-\"".concat(randomId)
  }, title ? title : 'icon representing circle'), (0, _core.jsx)("circle", {
    cx: "250",
    cy: "250",
    r: "220"
  }), text && text.length > 0 && (0, _core.jsx)(TextInCircle, {
    text: text,
    textColor: textColor
  }));
}, {
  target: "e8jzuww0"
})("width:", function (props) {
  return props.width ? props.width : '100%';
}, ";min-width:", function (props) {
  return props.width ? props.width : '100%';
}, ";max-width:50px;fill:", function (props) {
  return props.fill ? props.fill : (0, _styledSystem.themeGet)('colors.neutral.1');
}, ";transition:all 0.25s;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  textColor: 'white',
  text: ''
}), (0, _recompose.setPropTypes)({
  width: _propTypes.default.string,
  fill: _propTypes.default.string,
  title: _propTypes.default.string,
  text: _propTypes.default.string,
  textColor: _propTypes.default.string
}), (0, _recompose.withProps)(function () {
  return {
    randomId: Math.floor(Math.random() * 100000)
  };
}), (0, _recompose.setDisplayName)('CircleText'))(CircleText);

exports.default = _default;